import {Component, EventEmitter, Input, OnChanges, Output} from "@angular/core";

@Component({
	selector: "form-status",
	template: `
		<div class="form_statussection">
			<ng-container *ngIf="showSavingIcon">
				<div class="statusicon">
					<img alt="saving" src="/fly-garmin/img/loading/spinner-blue.gif"
						 title="Saving"/>
				</div>
				<div class="statustext">{{ savingText }}</div>
			</ng-container>
			<ng-container *ngIf="showCompleteIcon">
				<div class="statusicon">
					<img alt="complete" src="/fly-garmin/img/status/medium/success.gif"
						 title="Complete"/>
				</div>
				<div class="statustext"> {{ completeText }}</div>
			</ng-container>
		</div>
	`,
})
export class FormStatusComponent implements OnChanges {
	@Input() showSavingIcon: boolean = false;
	@Input() showCompleteIcon: boolean = false;
	@Input() showCompleteText: boolean = false;
	@Input() savingText: string;
	@Input() completeText: string;
	@Output() clearStatusMessage = new EventEmitter();

	ngOnChanges() {
		if (this.showCompleteIcon) {
			setTimeout(() => { this.clearStatusMessage.emit() }, 1500);
		}
	}
}
